import { Relationship, RelationshipNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: RelationshipNameFragment) {
	return instance.id;
}

export function condensedRelationshipType(instances: Pick<Relationship, "relationshipType">[]) {
	if (instances.length === 0) {
		return "";
	}

	const relationshipTypes = new Set(instances.map((instance) => Fields.relationshipType(instance.relationshipType)));
	if (relationshipTypes.size === 1) {
		return relationshipTypes.values().next().value;
	}

	return "Multiple";
}
